import React from 'react';
import { FormGroup, Form } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import DatePicker from '../../../common/forms/input/DatePicker';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import FormFooter from '../../../common/forms/FormFooter';
import AgencySelect from '../../../common/forms/select/AgencySelect';
import LocationSelect from '../../../common/forms/select/LocationSelect';

const isAfterFromDate = (toDateString, { fromDateString }) =>
  toDateString && fromDateString
    ? validateEndDate(toDateString, fromDateString)
    : undefined;

const ItineraryBoardingReportSearchForm = ({ handleSubmit, loading, extraButtons }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Agencia Embarque" required>
        <Field
          name="agency"
          component={AgencySelect}
          isClearable
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Destinos">
        <Field
          name="locationIds"
          component={LocationSelect}
          showAll
          isClearable
          isMulti
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={DatePicker}
          validate={[isRequired, isAfterFromDate]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonText="Buscar"
      saveButtonIcon="fa fa-search"
      saveButtonColor="primary"
      saveButtonDisabled={loading}
    >
      {typeof extraButtons === 'function'
        ? extraButtons({ handleSubmit, loading })
        : extraButtons}
    </FormFooter>
  </Form>
);

ItineraryBoardingReportSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  extraButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

ItineraryBoardingReportSearchForm.defaultProps = {
  loading: false,
  extraButtons: false
};

export default reduxForm({
  form: 'ItineraryBoardingReportSearchForm',
})(ItineraryBoardingReportSearchForm);